
export const roomToCoordinate = new Map<string, number[]>([
  ["A01", [2280, 320]],
  ["A02", [2280, 690]],
  ["A03", [2280, 1100]],
  ["A04", [2280, 1500]],
  ["A05", [2280, 2140]],
  ["A06", [2280, 2540]],
  ["A07", [2280, 2850]],
  ["A08", [2350, 3450]],
  ["A09", [1960, 3450]],
  ["A10", [1580, 3450]],
  ["A11", [1200, 3450]],
  ["A12", [800, 3450]],
  ["A13", [200, 3030]],
  ["A14", [200, 2600]],
  ["A15", [200, 2230]],
  ["A16", [200, 1850]],
  ["A17", [200, 1420]],
  ["A18", [200, 730]],
  ["A19", [750, 520]],
  ["A20", [1110, 400]],
  ["A21", [1475, 400]],
]);

export const zoneToRoomToPolygonCoord = new Map<string, Map<string, number[][]>>([
  ["ALPHA", 
    new Map<string, number[][]>([
      ["A01", [[1996, 88], [1996, 504], [2545, 504], [2545, 88]]],
      ["A02", [[1996, 500], [1996, 872], [2545, 872], [2545, 500]]],
      ["A03", [[1996, 892], [1996, 1308], [2545, 1308], [2545, 892]]],
      ["A04", [[1996, 1308], [1996, 1680], [2545, 1680], [2545, 1308]]],
      ["A05", [[1996, 1940], [1996, 2348], [2545, 2348], [2545, 1940]]],
      ["A06", [[1996, 2348], [1996, 2724], [2545, 2724], [2545, 2348]]],
      ["A07", [[1996, 2748], [1996, 3000], [2545, 3000], [2545, 2748]]],
      ["A08", [[2172, 3288], [2172, 3576], [2554, 3576], [2554, 3288]]],
      ["A09", [[1788, 3288], [1788, 3576], [2148, 3576], [2148, 3288]]],
      ["A10", [[1412, 3288], [1412, 3576], [1768, 3576], [1768, 3288]]],
      ["A11", [[1020, 3288], [1020, 3576], [1392, 3576], [1392, 3288]]],
      ["A12", [[636, 3288], [636, 3576], [1000, 3576], [1000, 3288]]],
      ["A13", [[44, 2812], [44, 3248], [368, 3248], [368, 2812]]],
      ["A14", [[44, 2420], [44, 2792], [368, 2792], [368, 2420]]],
      ["A15", [[44, 2041], [44, 2402], [368, 2402], [368, 2041]]],
      ["A16", [[44, 1649], [44, 2017], [368, 2017], [368, 1649]]],
      ["A17", [[44, 1206], [44, 1627], [368, 1627], [368, 1206]]],
      ["A18", [[50, 525], [50, 934], [364, 934], [364, 525]]],
      ["A19", [[590, 370], [590, 688], [912, 688], [912, 370]]],
      ["A20", [[936, 96], [936, 688], [1312, 688], [1312, 96]]],
      ["A21", [[1312, 96], [1312, 688], [1664, 688], [1664, 96]]],
    ])
  ],
  ["BRAVO", 
    new Map<string, number[][]>([
      ["B01", [[2059, 1264], [2059, 1560], [2401, 1560], [2401, 1264]]],
      ["B02", [[1698, 1264], [1698, 1560], [2038, 1560], [2038, 1264]]],
      ["B03", [[1332, 1264], [1332, 1560], [1678, 1560], [1678, 1264]]],
      ["B04", [[970, 1264], [970, 1560], [1314, 1560], [1314, 1264]]],
      ["B05", [[598, 1264], [598, 1560], [949, 1560], [949, 1264]]],
      ["B06", [[30, 1182], [30, 1560], [349, 1560], [349, 1182]]],
      ["B07", [[30, 799], [30, 1160], [349, 1160], [349, 799]]],
      ["B08", [[603, 21], [603, 314], [941, 314], [941, 21]]],
      ["B09", [[970, 21], [970, 314], [1314, 314], [1314, 21]]],
      ["B10", [[1333, 21], [1333, 314], [1678, 314], [1678, 21]]],
      ["B11", [[1698, 21], [1698, 314], [2038, 314], [2038, 21]]],
      ["B12", [[2058, 21], [2058, 314], [2406, 314], [2406, 21]]],
    ])
  ],
  ["CARDINAL", 
    new Map<string, number[][]>([
      ["C01", [[2059, 1264], [2059, 1560], [2401, 1560], [2401, 1264]]],
      ["C02", [[1698, 1264], [1698, 1560], [2038, 1560], [2038, 1264]]],
      ["C03", [[1332, 1264], [1332, 1560], [1678, 1560], [1678, 1264]]],
      ["C04", [[970, 1264], [970, 1560], [1314, 1560], [1314, 1264]]],
      ["C06", [[30, 978], [30, 1351], [349, 1351], [349, 978]]],
      ["C07", [[30, 403], [30, 780], [349, 780], [349, 403]]],
      ["C08", [[36, 21], [36, 381], [354, 381], [354, 21]]],
      ["C09", [[600, 21], [600, 314], [946, 314], [946, 21]]],
      ["C10", [[970, 21], [970, 314], [1314, 314], [1314, 21]]],
      ["C11", [[1333, 21], [1333, 314], [1678, 314], [1678, 21]]],
      ["C12", [[1698, 21], [1698, 314], [2038, 314], [2038, 21]]],
      ["C13", [[2058, 21], [2058, 314], [2406, 314], [2406, 21]]],
    ])
  ],
  ["DELTA", 
    new Map<string, number[][]>([
      ["D01", [[50, 1618], [50, 2111], [387, 2111], [387, 1618]]],
      ["D02", [[403, 1618], [403, 2111], [700, 2111], [700, 1618]]],
      ["D03", [[737, 1618], [737, 2111], [1050, 2111], [1050, 1618]]],
      ["D04", [[1067, 1618], [1067, 2111], [1381, 2111], [1381, 1618]]],
      ["D05", [[56, 16], [56, 457], [397, 457], [397, 16]]],
      ["D06", [[397, 16], [397, 457], [663, 457], [663, 16]]],
      ["D07", [[680, 16], [680, 457], [1014, 457], [1014, 16]]],
      ["D08", [[1014, 16], [1014, 457], [1364, 457], [1364, 16]]],
      ["D09", [[1791, 453], [1791, 720], [2202, 720], [2202, 453]]],
      ["D10", [[1791, 720], [1791, 958], [2202, 958], [2202, 720]]],
      ["D11", [[1791, 958], [1791, 1200], [2202, 1200], [2202, 958]]],
      ["D12", [[1791, 1200], [1791, 1408], [2202, 1408], [2202, 1200]]],
    ])
  ],
  ["EMERALD", 
    new Map<string, number[][]>([
      ["E01", [[92, 78], [92, 610], [948, 610], [948, 78]]],
      ["E02", [[694, 1138], [694, 1718], [1498, 1718], [1498, 1138]]],
      ["E03", [[1518, 1138], [1518, 1718], [2344, 1718], [2344, 1138]]],
    ])
  ],
  ["FOXTROT", 
    new Map<string, number[][]>([
      ["FT01", [[2017, 361], [2017, 660], [2401, 660], [2401, 361]]],
      ["FT02", [[1627, 361], [1628, 660], [1999, 660], [1999, 361]]],
      ["FT03", [[1230, 361], [1230, 660], [1605, 660], [1605, 361]]],
      ["FT04", [[837, 361], [837, 660], [1212, 660], [1212, 361]]],
      ["FT05", [[58, 361], [58, 680], [351, 680], [351, 361]]],
      ["FT06", [[618, 39], [618, 339], [958, 339], [958, 39]]],
    ])
  ],
]);

export const zoneToImageSize = new Map<string, number[]>([
  ["ALL", [9660, 16384]],
  ["ALPHA", [2574, 3602]],
  ["BRAVO", [2448, 1602]],
  ["CARDINAL", [2448, 1578]],
  ["DELTA", [2240, 2162]],
  ["EMERALD", [2448, 1760]],
  ["FOXTROT", [2450, 1200]],
]);

export const zoneToAllScalingFactor = new Map<string, number>([
  ["ALPHA", 1.86],
  ["BRAVO", 1.97],
  ["CARDINAL", 1.97],
  ["DELTA", 1.95],
  ["EMERALD", 0.96],
  ["FOXTROT", 1.95],
]);

export const zoneToAllOffset = new Map<string, number[]>([
  ["ALPHA", [21, 0]],
  ["BRAVO", [21, 6655]],
  ["CARDINAL", [21, 9720]],
  ["DELTA", [5300, 12150]],
  ["EMERALD", [5280, 4990]],
  ["FOXTROT", [21, 12130]],
]);
